import { Component, OnInit, OnDestroy } from '@angular/core';
import { MeetingService } from '../../services/meeting.service';
import { LocalStorageService } from 'angular-2-local-storage';
import { Router } from '@angular/router';
import { CookieService } from 'angular2-cookie/services/cookies.service';
import { ActivatedRoute } from '@angular/router';

declare var $: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, OnDestroy {

  busy: Promise<any>;
  person: any = {};
  method: any = 'Login';
  action: any = 'login';
  error: any;
  rememberme: any;
  message: any;
  msg: any;
  e_msg: any;
  interval: any;

  constructor(
    public meetingService: MeetingService,
    private storage: LocalStorageService,
    public route: ActivatedRoute,
    public router: Router,
    private _cookieService: CookieService,
    ) {
    if (_cookieService) {
       this.person.name = this._cookieService.get('username');
       this.rememberme = this._cookieService.get('remember');
       this.msg = this._cookieService.get('msg');
       this.interval = setTimeout(() => {
         this._cookieService.remove('msg');
         this.msg = '';
         $('.alert').fadeTo(2000, 500).slideUp(500, function() {
            $('.alert').slideUp(500);
        });
       }, 30000);
       this.e_msg = this._cookieService.get('e_msg');
       this.interval = setTimeout(() => {
         this._cookieService.remove('e_msg');
         this.e_msg = '';
         $('.alert').fadeTo(2000, 500).slideUp(500, function() {
            $('.alert').slideUp(500);
        });
       }, 30000);
    }


  }

  ngOnInit() {
    const msg = this.route.snapshot.queryParams['message'];
    if (msg) {
      this.message = msg;
      $('.messagealert').empty();
      $('.messagealert')
      .append(`
        <div class="alert alert-success alert-dismissable messagealert">
          <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>'
          ${this.message}
        </div>`);
        setTimeout(function() {
        $('.alert').fadeTo(2000, 500).slideUp(500, function() {
           $('.alert').slideUp(500);
        });
      }, 30000);
      // console.log(this.code);
    }
  }

  getLogin() {
    if (this.rememberme) {
      this._cookieService.put('username', this.person.name);
      this._cookieService.put('remember', this.rememberme);
    }
    // console.log(this.person.name);
    // console.log(this.person.pass);
    // console.log(this.method);
    // console.log(this.action);
    this.busy = this.meetingService.getLogin(this.person.name, this.person.pass, this.method, this.action).subscribe(response => {
      if (response) {
        if (response[0].success === 1) {
          // console.log(response);
          this.storage.set('user', response);
          const link = ['/'];
          this.router.navigate(link);
        } else {
          this.error = response[0].message;
          window.scrollTo(0, 0);
        }
      }
    });
  }

  registerPage() {
    this.router.navigate(['/register'], { queryParams: { city: '1' } });
  }

  ngOnDestroy() {
    this._cookieService.remove('msg');
    this._cookieService.remove('e_msg');
  }

}
